import { createApp } from "vue"
import ElementPlus from "element-plus"
import "element-plus/dist/index.css"
import zhCn from "element-plus/dist/locale/zh-cn.mjs"
import * as ElementPlusIconsVue from "@element-plus/icons-vue"

import App from "./App.vue"
import router from "./router"
import store from "./store"
import permissionDirective from "./directives/permission"

// 引入全局样式（修复字体颜色问题）
import "./assets/global.css"

const app = createApp(App)

// 注册Element Plus
app.use(ElementPlus, {
  locale: zhCn,
})

// 注册Element Plus图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

// 注册路由
app.use(router)

// 注册Vuex
app.use(store)

// 注册权限指令
app.directive("permission", permissionDirective)

// 移除了不必要的重定向代码，后台管理系统需要使用/admin路径

app.mount("#app")
